var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconfeatherPhoneCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.806,
    height: 28.855,
    viewBox: "0 0 28.806 28.855",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-phone-call",
    "data-name": "Icon feather-phone-call",
    d: "M19.054,6.411a6.139,6.139,0,0,1,4.85,4.85M19.054,1.5a11.05,11.05,0,0,1,9.761,9.749m-1.228,9.8v3.683a2.456,2.456,0,0,1-2.677,2.456,24.3,24.3,0,0,1-10.6-3.769A23.943,23.943,0,0,1,6.947,16.05,24.3,24.3,0,0,1,3.178,5.4,2.456,2.456,0,0,1,5.621,2.728H9.3A2.456,2.456,0,0,1,11.76,4.84a15.765,15.765,0,0,0,.859,3.45,2.456,2.456,0,0,1-.553,2.591L10.508,12.44a19.645,19.645,0,0,0,7.367,7.367l1.559-1.559a2.456,2.456,0,0,1,2.591-.553,15.765,15.765,0,0,0,3.45.859A2.456,2.456,0,0,1,27.587,21.047Z",
    transform: "translate(-1.667 0.156)",
    fill: "none",
    stroke: "#cf2969",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconfeatherPhoneCall);
export default __webpack_public_path__ + "static/media/Icon feather-phone-call.57d1c5be44c4770b5822e5c91ad082b2.svg";
export { ForwardRef as ReactComponent };